import React from 'react';
import MiniItemCard from './MiniItemCard';
import { Grid, Box } from '@chakra-ui/react';
import { BusinessItem } from '../../store/page/types';

interface MiniItemGridProps {
  items: BusinessItem[];
  businessName?: string;
}

const MiniItemGrid: React.FC<MiniItemGridProps> = ({ items, businessName }) => {
  return (
    <Grid
      templateColumns="repeat(auto-fill, minmax(330px, 0fr))"
      gap={2}
      justifyContent="center"
      overflowX="auto"
    >
      {items.map((item, index) => (
        <Box key={index} minWidth="330px">
          <MiniItemCard item={item} businessName={businessName} />
        </Box>
      ))}
    </Grid>
  );
};

export default MiniItemGrid;
